import React from 'react';
import toast from 'react-hot-toast';
import { Formik } from 'formik';
import * as Yup from 'yup';

import Field from 'legacy/common/components/wysiwyg-form/Field';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import { useConfirmStudentEmail } from 'legacy/groups/hooks';
import { AssociationDto } from 'legacy/groups/types';

import { GoToStepFn, StepsId } from '../../types';

interface Props {
  goToStep: GoToStepFn;
  emailDomains: string[];
  association: AssociationDto;
}

const EmailDomainValidation = Yup.object({
  email: Yup.string()
    .email('Invalid email format')
    .required('Field is required')
});

function StudentEmailForm({ emailDomains, goToStep, association }: Props) {
  const { mutate: confirmEmail } = useConfirmStudentEmail();

  const handleConfirmEmail = (values) => {
    confirmEmail(
      {
        associationId: association.id,
        email: values.email
      },
      {
        onSuccess: () => {
          toast.success(
            'Confirmation code sent successfully. Please check your emails.'
          );
          goToStep(StepsId.ConfirmCodeStep);
        },
        onError: (err) => {
          toast.error(err?.message || 'An error occurred.');
        }
      }
    );
  };

  return (
    <Formik
      enableReinitialize
      onSubmit={handleConfirmEmail}
      validationSchema={EmailDomainValidation}
      initialValues={{
        email: ''
      }}
    >
      {({ handleSubmit, errors }) => (
        <>
          <div className="px-4 py-4 flex gap-4 flex-col">
            <p className="font-normal text-base">
              This association requires your student email with one of these
              domains:
              <br />
              <span className="font-bold">
                {emailDomains
                  .map(
                    (domain, index) =>
                      ` @${domain}${index < emailDomains.length - 1 ? ',' : ''}`
                  )
                  .join('')}
              </span>
            </p>
            <div>
              <Field
                type="text"
                label="Student Email"
                id="email"
                name="email"
                placeholder="e.g. student@schoolDomain.com"
              />
            </div>
          </div>
          <div className="px-4 border-t-1 pt-6">
            <Button
              type={ButtonType.Primary}
              newRadius
              onClick={handleSubmit}
              disabled={Object.keys(errors).length > 0}
            >
              Confirm email
            </Button>
          </div>
        </>
      )}
    </Formik>
  );
}

export default StudentEmailForm;
